import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from '@mui/material';

interface CustomerInfoModalProps {
  open: boolean;
  onClose: () => void;
//   onSubmit: (data: { name: string; email: string; phone: string }) => void;
}

const CustomerInfoModal: React.FC<CustomerInfoModalProps> = ({ open, onClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

//   const handleSubmit = () => {
//     if (name && email && phone) {
//       onSubmit({ name, email, phone });
//       onClose();
//     } else {
//       alert('Please fill out all fields.');
//     }
//   };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{textAlign: "center"}}>Get in touch with us</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Full Name"
          margin="dense"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          fullWidth
          label="Email Address"
          type="email"
          margin="dense"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          fullWidth
          label="Phone Number"
          type="tel"
          margin="dense"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button  variant="contained" sx={{background: "#ff4500", borderRadius: "10px", padding: "10px"}}>Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomerInfoModal;
